var map = {
	"./american-express-logo.png": 3187,
	"./amex-logo.png": 3703,
	"./diners-club-logo.png": 2778,
	"./discover-logo.png": 7643,
	"./jcb-logo.png": 337,
	"./maestro-logo.png": 6415,
	"./mastercard-logo.png": 8828,
	"./unionpay-logo.png": 8975,
	"./visa-logo.png": 1417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7313;